import { SendFormsOrigin } from '../../../../types';
import { StoreConstants } from '../../../constants';
import { FormsSendingExperienceStoreState } from '../../../types';

interface ResetStorePayload {
  origin: SendFormsOrigin;
  currentState: FormsSendingExperienceStoreState;
}

export function resetStore({ currentState, origin }: ResetStorePayload): FormsSendingExperienceStoreState {
  let newState: FormsSendingExperienceStoreState = {
    ...StoreConstants.INITIAL_STATE,
    // Reset to the first step
    currentStep: currentState.steps[0],
    // Maintain the following from the current state
    steps: currentState.steps,
    formsEnabledLocationIds: currentState.formsEnabledLocationIds,
    locationId: currentState.locationId,
    temporarilyHideModal: currentState.temporarilyHideModal,
    areFormsEnabledLocationIdsSet: currentState.areFormsEnabledLocationIdsSet,
  };

  switch (origin) {
    case SendFormsOrigin.CONTACTS:
      newState = {
        ...newState,
        // Restore the contact details
        personId: currentState.personId,
        firstName: currentState.firstName,
        lastName: currentState.lastName,
        fullName: currentState.fullName,
      };
      break;

    case SendFormsOrigin.FORMS:
      newState = {
        ...newState,
        // Restore the document to send
        formOrPacketToSend: currentState.formOrPacketToSend,
      };
      break;

    case SendFormsOrigin.KIOSK:
      newState = {
        ...newState,
        // Restore the selected delivery method to "kiosk"
        selectedDeliveryMethod: 'kiosk',
      };
      break;

    case SendFormsOrigin.MESSAGING:
      newState = {
        ...newState,
        // Restore the person details (personId is provided externally for messaging origin)
        personId: currentState.personId,
        firstName: currentState.firstName,
        lastName: currentState.lastName,
        fullName: currentState.fullName,
      };
      break;
  }

  return newState;
}
